function checkForSearchFlight() {
	if($("#fromAirport").val() == "" || $("#toAirport").val() == "") {
		alert(FmtMessage.getMessage('js.flight.search.empty.city.warning'));
		return;
	}

	if($("#fromAirportCity").val() && $("#fromAirportCity").val() ==  $("#toAirportCity").val()) {
    	alert(FmtMessage.getMessage('js.flight.search.warning'));
    	return;
    }

	var adult = $("#paxADT").val();
	var child = $("#paxCHD").val();
	var infant = $("#paxINF").val();
	
	var totalAdult = parseInt(adult);
	var totalPax = totalAdult + parseInt(child) + parseInt(infant);

	if (totalPax < 1) {
		alert(FmtMessage.getMessage('js.search.warning.1pax'));
	} else if (totalAdult < 1) {
		alert(FmtMessage.getMessage('js.search.warning.1adult'));
	} else if (totalAdult < infant) {
		alert(FmtMessage.getMessage('js.search.warning.infant.adult'));
	} else if (totalPax > 9) {
		alert(sprintf(FmtMessage.getMessage('js.search.warning.paxcount'), 9));
	} else {
		var formValid = $("#searchForm").valid();
		if (formValid) {
			$('#loading').modal('show');
			var searchUrl = URL_MAPPING.resolveUrl('/searchFlights');
			document.searchForm.action = searchUrl;
			document.searchForm.submit();
		}
	}
}

var Transfer = {
	transferNumAdult:null,
	transferNumChild:null,
	transferNumInfant:null,
	resultTable:$("#transferResultTable div.result-row")
};

var transferSearch = {
	searchAutoCompleteIdFrom:null,
	searchAutoCompleteIdTo:null,
	searchUrlFrom:null,
	searchUrlTo:null,
	fromDate:null,
	toDate:null
};

var autoCompleteResult="";
var totalAdult = 0;
var totalChild = 0;
var totalRoomCount = 0;

var hotelSearch = {
	searchAutoCompleteId:null,
	searchUrl:null,
	fromDate:null,
	toDate:null
};

$.extend($.ui.menu.prototype.options, {
    items: "> :not(.ui-autocomplete-category)"
});

$(document).ready(function(){
	$('#loading').modal({
		show : false
	});
	
	// Server renders dates with Arabic-Indic digits for 'ar'; normalize them to Latin digits.
	// moment parses them via the preparse set in /js/momentArabicDigits.js.
	$('#departureDate, #returnDate').each(function () {
		var value = $(this).val();
		var parsed = moment(value, 'DD.MM.YYYY');
		if (value && parsed.isValid()) {
			$(this).val(parsed.format('DD.MM.YYYY'));
		}
	});

	$('#departureDate').daterangepicker({
	  singleDatePicker: true,
      minDate: moment(),
      minYear: 2022,
	  maxYear: parseInt(moment().format('YYYY'),10),
	  autoApply: true,
	  locale: {
	    format: 'DD.MM.YYYY'
	  }
	});
	
	$('#departureDate').on('apply.daterangepicker', function(ev, picker) {
	  $('label.showDepDate.day-name').html(picker.startDate.format('ddd'));
	  $('div.showDepDate.day-no').html(picker.startDate.format('DD'));
	  $('div.showDepDate.month-name').html(picker.startDate.format('MMM'));
	  $('input[name="departureDate"]').val(picker.startDate.format('DD.MM.YYYY'));
	  $('img.showDepImg').hide();
	  $('.showDepDate').show();
	});
	
	$('#returnDate').daterangepicker({
	  singleDatePicker: true,
	  autoUpdateInput: false,
      minDate: moment(),
      minYear: 2022,
	  maxYear: parseInt(moment().format('YYYY'),10),
	  autoApply: true,
	  locale: {
	    format: 'DD.MM.YYYY'
	  }
	});
	
	$('#returnDate').on('apply.daterangepicker', function(ev, picker) {
	  $('label.showRetDate.day-name').html(picker.startDate.format('ddd'));
	  $('div.showRetDate.day-no').html(picker.startDate.format('DD'));
	  $('div.showRetDate.month-name').html(picker.startDate.format('MMM'));
	  $('input[name="returnDate"]').val(picker.startDate.format('DD.MM.YYYY'));
	  $('img.showRetImg').hide();
	  $('.showRetDate').show();
	});
	
	$('[name="flightRadio"]').on('change',function(){
		var value = $(this).val();
		if (value == 1){
			$('#returnDate').prop('disabled',true);
			$('img.showRetImg').show();
			$('.showRetDate,#returnDate').hide();
		} else {
			$('#returnDate').prop('disabled',false);
			$('img.showRetImg').hide();
			$('.showRetDate,#returnDate').show();
		}
	});
	
	$('#applyClassAndPax').on('click',function(){
		var adult = $("#paxADT").val();
		var child = $("#paxCHD").val();
		var infant = $("#paxINF").val();
		var totalPax = parseInt(adult) + parseInt(child) + parseInt(infant);
		$('#divPax').html(totalPax);
		
		var selectedClass = $('#selectClass option:selected').data('short');
		$('#divClass').html(selectedClass);
	});
	
	$.ui.autocomplete.prototype._renderItem = function( ul, item){
		if (item.atype == 2) {
			ultext = "<a class='atype"+item.atype+"' >" + item.value + "</a>"; 
		    
		   	$( "<li></li>" ).data( "ui-autocomplete-item", item ).append( ultext).appendTo( ul );
		    
		    for(var i=0; i < item.airports.length;i++) {
		    	var airport = item.airports[i];
		    	
		    	ultext ="<a class='atype1'>" + airport.Name + " " +airport.Code + "</a></li>" ;
		    	
		    	$( "<li></li>" ).data( "ui-autocomplete-item", airport ).append( ultext).appendTo( ul );
		    }
		    return $( "<li></li>" );
		} else {
			// normal airport 
			ultext =  "<a class='' >" + item.value + "</a>" ;
			return $( "<li></li>" ).data( "ui-autocomplete-item", item ).append( ultext).appendTo( ul );
		}
	};
	
	$(".airportAutoComplete").autocomplete({
		source : function(request, response) {
			$.ajax({
				url : "/airports",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term
				},
				success : function(data) {
					response($.map(data.ResultSet.Result.slice(0,10), function(item) {
						return {
							value :  item.CityName + ", " + item.Name + " (" + item.Code + "), " + item.CountryCode,
							id : item.id,
							atype: item.type,
							name : item.Name,
							code : item.Code,
							cityName: item.CityName,
							countryName: item.CountryName,
							countryCode : item.CountryCode,
							airports : item.airports,
							city : item.CityCode
						};
					}));
				}
			});
		},
		select : function(event, ui) {
			document.activeElement.blur();
			$('[name="' + $(this).attr('name') + 'Id"]', this.form).val(ui.item.id);
			if (ui.item.city) {
			  $('[name="' + $(this).attr('name') + 'City"]', this.form).val(ui.item.city);
			}else if (ui.item.CityCode) {
			  $('[name="' + $(this).attr('name') + 'City"]', this.form).val(ui.item.CityCode);
			}
			$(this).data('autoCompleteId', ui.item.id);
			var item = Object.assign({}, ui.item);
	        delete item['airports'];
			$.cookie($(this).attr('name'), JSON.stringify(item), { expires : 365, path : '/' });
			
			if ($(this.form).attr('name') == 'searchForm') {
				if (ui.item.cityName) {
					$('#' + $(this).attr('name') + 'Div').html(ui.item.name + " (" + ui.item.code + ")");
					$('#' + $(this).attr('name')).val(ui.item.cityName);
				} else {
					$('#' + $(this).attr('name') + 'Div').html(ui.item.Name + " (" + ui.item.Code + ")");
					$('#' + $(this).attr('name')).val(ui.item.CityName);
				}
			} else {
				if (ui.item.cityName) {
					$('#' + $(this).attr('name') + 'Div').html(ui.item.name + " (" + ui.item.code + ")");
					$('#' + $(this).attr('name')).val(ui.item.cityName);
					$('#' + $(this).attr('name') + 'Sum').val(ui.item.cityName + ", " + ui.item.name);
				} else {
					$('#' + $(this).attr('name') + 'Div').html(ui.item.Name + " (" + ui.item.Code + ")");
					$('#' + $(this).attr('name')).val(ui.item.CityName);
					$('#' + $(this).attr('name') + 'Sum').val(ui.item.CityName + ", " + ui.item.Name);
				}
			}
			return false;
		},
		open: function(event, ui) {
	        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
	    },
		minLength : 3
	}).change(function(event) {
		var itemId = $('[name="' + $(this).attr('name') + 'Id"]', this.form).val();
		var itemCity = $('[name="' + $(this).attr('name') + 'City"]', this.form).val();
	
		var item = {value: this.value, id: itemId, city:itemCity};
		$.cookie($(this).attr('name'), JSON.stringify(item), { expires : 365, path : '/' });
	});
	
	$(".airportAutoComplete").click(function() {
		$(this).select();
	});
	
	$(".setSelection").click(function() {
		$(this).focus();
		$(this).get(0).setSelectionRange(0,$(this).val().length);
	});
	
	// Start - Location set from Cookie
	if(!$('#fromAirport').val()){
		var itemJson = $.cookie('fromAirport', { path : '/' });
		if(itemJson){
			var item = JSON.parse(itemJson);
	
			if ('airports' in item){
				delete item['airports']
				var newItem = Object.assign({}, item);
	            $.cookie('fromAirport', JSON.stringify(newItem), { expires : 365, path : '/' });
	        }
	
			if (item.cityName) {
				$('#fromAirport').val(item.cityName);
				$('#fromAirportDiv').html(item.name + " (" + item.city + ")");
			} else if (item.CityName) {
				$('#fromAirport').val(item.CityName);
				$('#fromAirportDiv').html(item.Name + " (" + item.Code + ")");
			}
			$('[name="fromAirportId"]').val(item.id);
			if (item.city) {
				$('[name="fromAirportCity"]').val(item.city);
			}else if (item.CityCode) {
				$('[name="fromAirportCity"]').val(item.CityCode);
			}
		}
	}
	
	if(!$('#toAirport').val()){
		var itemJson = $.cookie('toAirport', { path : '/' });
		if(itemJson){
			var item = JSON.parse(itemJson);
	
	        if ('airports' in item){
	            delete item['airports']
	            var newItem = Object.assign({}, item);
	            $.cookie('toAirport', JSON.stringify(newItem), { expires : 365, path : '/' });
	        }
	
			if (item.cityName) {
				$('#toAirport').val(item.cityName);
				$('#toAirportDiv').html(item.name + " (" + item.city + ")");
			} else if (item.CityName) {
				$('#toAirport').val(item.CityName);
				$('#toAirportDiv').html(item.Name + " (" + item.Code + ")");
			}
			$('[name="toAirportId"]').val(item.id);
			if (item.city) {
				$('[name="toAirportCity"]').val(item.city);
			}else if (item.CityCode) {
				$('[name="toAirportCity"]').val(item.CityCode);
			}
		}
	}
	
	$('#transferDate').daterangepicker({
	  singleDatePicker: true,
      minDate: moment(),
      minYear: 2022,
	  maxYear: parseInt(moment().format('YYYY'),10),
	  autoApply: true,
	  locale: {
	    format: 'DD.MM.YYYY'
	  }
	});
	
	$('#transferDate').on('apply.daterangepicker', function(ev, picker) {
	  $('label.showTrfDate.day-name').html(picker.startDate.format('dddd'));
	  $('div.showTrfDate.day-no').html(picker.startDate.format('DD'));
	  $('div.showTrfDate.month-name').html(picker.startDate.format('MMM'));
	  $('input[name="transferDate"]').val(picker.startDate.format('DD.MM.YYYY'));
	  $('img.showTrfImg').hide();
	  $('.showTrfDate').show();
	  $('.showTrfDate').removeClass("opacity-0 position-absolute");
	});
	
	$('#trfReturnDate').daterangepicker({
	  singleDatePicker: true,
	  autoUpdateInput: false,
      minDate: moment(),
      minYear: 2022,
	  maxYear: parseInt(moment().format('YYYY'),10),
	  autoApply: true,
	  locale: {
	    format: 'DD.MM.YYYY'
	  }
	});
	
	$('#trfReturnDate').on('apply.daterangepicker', function(ev, picker) {
	  $('label.showTrfRetDate.day-name').html(picker.startDate.format('dddd'));
	  $('div.showTrfRetDate.day-no').html(picker.startDate.format('DD'));
	  $('div.showTrfRetDate.month-name').html(picker.startDate.format('MMM'));
	  $('#trfReturnDate').val(picker.startDate.format('DD.MM.YYYY'));
	  $('img.showTrfRetImg').hide();
	  $('.showTrfRetDate').show();
	  $('.showTrfRetDate').removeClass("opacity-0 position-absolute");
	});
	
	$('input.trf-people-count').on('change',function(){
		var pax = 0;
		$('input.trf-people-count').each(function(idx,cbx){
			pax += parseInt($(cbx).val());
		});
		$('#trfPax').html(pax);
	});
	
	var forms = document.querySelectorAll('#transferSearchForm');

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms)
      .forEach(function (form) {
        form.addEventListener('submit', function (event) {
		  if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          } else {
          	form.classList.add('was-validated');
		  	$('#loading').modal('show');
		  }
        }, false)
    });
	
    var pageName = $('[name="pageName"]').val();
    if(pageName){
        pageName = pageName.replace("/","");
        if( window.location.pathname.substring(1) == pageName){
            parseCookieSearchValues();
        }
    }
	
	$.widget("custom.autocomplete", $.ui.autocomplete, {
		_renderMenu : function(ul, items) {
			var that = this, currentCategory = "";
			$.each(items, function(index, item) {
				if (item.category != currentCategory) {
					if (item.category == 1) {
						ul.append("<li class='ui-autocomplete-category iconCity' >" + FmtMessage.getMessage('js.result.city')  + "</li>");
					} else if (item.category == 4 || item.category == 3) {
						ul.append("<li class='ui-autocomplete-category iconDistrict' >" + FmtMessage.getMessage('js.result.district') + "</li>");
					} else if (item.category == 2) {
						ul.append("<li class='ui-autocomplete-category iconHotel' >" + FmtMessage.getMessage('js.result.hotel') + "</li>");						
					} else if (item.category == 6) {
						ul.append("<li class='ui-autocomplete-category iconAirport' >" + FmtMessage.getMessage('js.result.airport') + "</li>");
					}

					currentCategory = item.category;
				}
				that._renderItemData(ul, item);
			});
		},
        _renderItem: function (ul, item) {
    		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
    		return $("<li></li>")
    			.data("item.autocomplete", item)
    			.append("<a>" + item.label + "</a>")
    			.appendTo(ul);
    	}
	});
	
	var re = null;
	$(".transferAutoComplete").click(function(){ //,#retransferFrom, #retransferTo
        var selected = $(this).data("selected");
        if(!selected){
            $(this).select();
            $(this).data("selected", true);
        }
	}).focusout(function(){
        $(this).data("selected", false);
        var value = this.value;
        var label = $(this).data("label");
        if(label != value){
            this.value = "";
            $("#" + this.id + "Id").val("");
        }
	}).autocomplete({
		source : function(request, response) {
			var otherAutoComplete = $('#' + $(this.element).data('dir')).val();
			$.ajax({
				url : "/transfer/locations",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term,
					otherAutoCompleteId : otherAutoComplete
				},
				success : function(data) {
					
					re = new RegExp("(" + $.ui.autocomplete.escapeRegex(request.term) + ")", "gi");
					response($.map(data, function(item) {
						return {
							value: item.name,
							category : item.type,
							id: item.id
						};
						
					}));
				}
			});
		},
		minLength : 2,
		open: function(event, ui) {
	        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
	    },
		select : function(event, ui) {
			document.activeElement.blur();
			$(this).data("label", ui.item.value);
			$("#" + this.id + "Id").val(ui.item.id);
			$("#" + this.id + "Type").val(ui.item.category);
			
			if($(this).attr("tabindex") == 1){
				transferSearch.searchAutoCompleteIdFrom = ui.item.id;
				transferSearch.searchUrlFrom = ui.item.value;
			}
			else{
				transferSearch.searchAutoCompleteIdTo = ui.item.id;
				transferSearch.searchUrlTo = ui.item.value;
			}
		}
	});	
	
	$.ui.autocomplete.prototype._renderItem = function (ul, item) {
		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
		return $("<li></li>")
			.data("item.autocomplete", item)
			.append("<a>" + item.label + "</a>")
			.appendTo(ul);
	};
	
	bindDatePicker();
	
	var isHotelDetail = $("[name='hotelDetail']").val();
    if(!isHotelDetail){
        parseHotelCookieSearchValues();
    }

	if(Hotel.source){
		var date = new Date();
		date.setTime(date.getTime() + (30 * 60 * 1000)); //30 minutes
		$.cookie('source', Hotel.source, { expires : date,  path : '/' });
	}
	
	$('.hotelAutoComplete').on('change', function() {
		$('html, body').animate({scrollTop: $("#hotelSearch").offset().top}, 500);
	});
	
	$.widget("custom.catcomplete", $.ui.autocomplete, {
		_renderMenu : function(ul, items) {
			var that = this, currentCategory = "";
			$.each(items, function(index, item) {
				if (item.category != currentCategory) {
					if (item.category == "HOTEL") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconHotel' >" + FmtMessage.getMessage('js.result.hotel') + "</li>");
					} else if (item.category == "CITY") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconCity' >" + FmtMessage.getMessage('js.result.city') + "</li>");
					} else if (item.category == "DISTRICT") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconDistrict' >" + FmtMessage.getMessage('js.result.district') + "</li>");
					}

					currentCategory = item.category;
				}
				that._renderItemData(ul, item);
			});
		},
        _renderItem: function (ul, item) {
    		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
    		return $("<li class='ui-autocomplete-item'></li>")
    			.data("ui-autocomplete-item", item)
    			.append("<a>" + item.label + "</a>")
    			.appendTo(ul);
    		}
	});
	
	var re = null;
	$(".hotelAutoComplete").catcomplete(
	{   delay: 500,
		source : function(request, response) {
			$.ajax({
				url : "/hotel/hotels",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term
				},
				success: function(data) {
					if(data == null){
						data = [];
					}
					
					var itemList = $.map(data, function(item) {
						return {
							value: item.name + " ( " + item.hotelCount + " "+ FmtMessage.getMessage('js.title.hotel.name') + " ) ",
							key: item.id,
							category : item.type,
							name : item.name,
							hotelId:item.hotelId
						};
					});
					
					re = new RegExp("(" + $.ui.autocomplete.escapeRegex(request.term) + ")", "gi");
					
					var itemListNew = getHotelItemLabels(itemList);
					response(itemListNew);
				}				
			});
		},
		minLength : 2,
		select: function (a, b) {
			document.activeElement.blur();
			if(b.item.hotelId){
				$('[name="id"]', this.form).val(b.item.hotelId);
			}
			$('[name="id"]', this.form).val(b.item.key);
			$(this).data("autoCompleteResult", b.item.value);
			
			if(!$('[name="urlHotelName"]').length ){
				$('<input>').attr({
				    type: 'hidden',
				    id: 'urlHotelName',
				    name: 'urlHotelName'
				}).appendTo(this.form);
			}
			$('[name="urlHotelName"]').val(b.item.name);
		},
		open: function(event, ui) {
	        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
	    }
	}).change(function (event) {
		if ($(this).data("autoCompleteResult") != this.value)
			$('[name="id"]', this.form).val("");
	});

	$.ui.autocomplete.prototype._renderItem = function (ul, item) {
		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
		return $("<li></li>")
			.data("ui-autocomplete-item", item)
			.append("<a>" + item.label + "</a>")
			.appendTo(ul);
		};

	bindRoomSelector();

	$(".hotelAutoComplete").click(function() {
		$(this).select();
	});
	
	var hotelForms = document.querySelectorAll('#hotelSearchForm');

    // Loop over them and prevent submission
    Array.prototype.slice.call(hotelForms)
      .forEach(function (form) {
        form.addEventListener('submit', function (event) {
            checkForSearchHotel(form,event);
        }, false)
    });
});

function parseCookieSearchValues(){
	if($.cookie('transferSearchValues')){
		var searchData = JSON.parse($.cookie("transferSearchValues"));
		$('#fromLocationId').val(searchData.searchAutoCompleteIdFrom);
		$('#fromLocation').val(searchData.searchUrlFrom);
		
		$('#toLocationId').val(searchData.searchAutoCompleteIdTo);
		$('#toLocation').val(searchData.searchUrlTo);
		if(searchData.fromDate !=null){
			$('input[name="transferDate"]').val(searchData.fromDate);
		}
		if(searchData.toDate != null){
			$('input[name="returnDate"]').val(searchData.toDate);
			$("#clearReturn").show();
		}
	}
}

window.onbeforeunload = function (){
	var date = new Date();
	date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); //24 hour
	if($.cookie('transferSearchValues')){
		var searchData = JSON.parse($.cookie("transferSearchValues"));
		if(!transferSearch.searchAutoCompleteIdFrom){
			transferSearch.searchAutoCompleteIdFrom = searchData.searchAutoCompleteIdFrom;
			transferSearch.searchUrlFrom = searchData.searchUrlFrom;
			}
		if(!transferSearch.searchAutoCompleteIdTo){
			transferSearch.searchAutoCompleteIdTo = searchData.searchAutoCompleteIdTo;
			transferSearch.searchUrlTo = searchData.searchUrlTo;
		}
		if(!transferSearch.fromDate){
			transferSearch.fromDate = searchData.fromDate;
			}
		if(!transferSearch.toDate){
			transferSearch.toDate = searchData.toDate;
		}
	}
	
	if(transferSearch.searchAutoCompleteIdFrom != null){
		$.cookie('transferSearchValues',  JSON.stringify(transferSearch), { expires : date,  path : '/' });
	}
};

function getHotelItemLabels(itemList){
	var itemListNew = $.map(itemList, function(item) {
		var category = item.category;
		if (category == "HOTEL"){
			item.value = item.name;
		}
		return item;
	});
	
	return itemListNew;
}

function bindDatePicker() {
	if ($('#dates').length == 0) {
		return;
	}
	
	$('#dates').daterangepicker({
      minDate: moment(),
      minYear: 2022,
      maxYear: parseInt(moment().format('YYYY'),10),
      locale: {
        format: 'DD.MM.YYYY'
      },
      startDate: $('input[name="checkInDate"]').val().length > 0 ? moment($('input[name="checkInDate"]').val(),'DD.MM.YYYY') : moment(),
      endDate: $('input[name="checkOutDate"]').val().length > 0 ? moment($('input[name="checkOutDate"]').val(),'DD.MM.YYYY') : moment()
    });
    
    $('#dates').on('apply.daterangepicker', function(ev, picker) {
  		$('input[name="checkInDate"]').val(picker.startDate.format('DD.MM.YYYY'));
  		$('input[name="checkOutDate"]').val(picker.endDate.format('DD.MM.YYYY'));
  		$('#nightsLabel').html(picker.endDate.diff(picker.startDate,'days'));
	});
}

function bindRoomSelector(context) {
	if (context == undefined) {
		context = document;
	}
	
	$(".roomSelect", context).on('change', function(event) {
		var roomCount = $(this).val();
		
		for ( var i = 1; i < 5; i++) {
			if (i <= roomCount) {
				$(".room" + i).addClass('d-flex').show();
			} else {
				$(".room" + i).hide().removeClass('d-flex');
			}
		}
		
		setTotalGuest($(this).closest("form"));
	}).change();

	$(".childCount", context).on('change', function (event) {
		var childCount =  parseInt(this.value);
		var index = this.name.split('_')[1];
		$("[name="+this.name+"]").val(childCount);

		for ( var i = 1; i < 4; i++) {
			if (i <= childCount) {
				$(".childAge" + index + i).show();
			} else {
				$(".childAge" + index + i).hide();
			}
		}
		
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".adultCount", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".childAge", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
	}).change();
}

function setTotalGuest(form) {
	var roomCount = parseInt(form.find("#glRoomCount").val());
	var totalAdultCount = 0;
	var totalChildCount = 0;
	for ( var i = 1; i <= roomCount; i++) {
		totalAdultCount = totalAdultCount + parseInt(form.find("[name=adultCount_" + i + "]").val());
		totalChildCount = totalChildCount + parseInt(form.find("[name=childCount_" + i + "]").val());
	}
	var totalGuest = totalAdultCount + totalChildCount;
	$(".labelGuest").html(totalGuest);
}

function parseHotelCookieSearchValues() {
    if (($('input[type=hidden][name="overrideSearchForm"]')
    	&& $('input[type=hidden][name="overrideSearchForm"]').val())) {
        putHotelCookieSearchValues();
    }
    
	if($.cookie('hotelSearchValues')){
		var now = moment();
		var searchData = JSON.parse($.cookie("hotelSearchValues"));
		$('.hotelAutoComplete').data("autoCompleteResult", searchData.searchAutoCompleteId);
		
		if(!$('[name="urlHotelName"]').length ){
			$('<input>').attr({
			    type: 'hidden',
			    id: 'urlHotelName',
			    name: 'urlHotelName'
			}).appendTo(this.form);
		}
		
		$('[name="urlHotelName"]').val(searchData.searchUrl);
		$('[name="hotelName"]').val(searchData.searchUrl);
		$('[name="id"]').val(searchData.searchAutoCompleteId);
		
		var from = null;
		var to = null;
		
		if (searchData.fromDate != null) {
			from = moment(searchData.fromDate, "DD.MM.YYYY");
			var formattedFromDate = searchData.fromDate;
			var checkinDate = from.format("DD MMM, YYYY");
			if(now.isAfter(from)){
				from = moment().add(1,'d');
				formattedFromDate = from.format("DD.MM.YYYY");
				checkinDate = from.format("DD MMM, YYYY");
			}
			
			$('#dates').data('daterangepicker').setStartDate(checkinDate);
  			$('input[name="checkInDate"]').val(formattedFromDate);
		}

		if (searchData.toDate != null) {
			to = moment(searchData.toDate, "DD.MM.YYYY");
			var formattedToDate = searchData.toDate;
			var checkoutDate = to.format("DD MMM, YYYY");
			if(now.isAfter(to)){
				to = moment().add(7,'d');
				formattedToDate = to.format("DD.MM.YYYY");
				checkoutDate = to.format("DD MMM, YYYY");
			}
			
			$('#dates').data('daterangepicker').setEndDate(checkoutDate);
  			$('input[name="checkOutDate"]').val(formattedToDate);
		}
		
		if (from != null && to != null) {
  			$('#nightsLabel').html(to.diff(from,'days') + ' NIGHT');
		}
	}
}

function putHotelCookieSearchValues(){
	var date = new Date();
	date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); //24 hour
	hotelSearch.searchAutoCompleteId = $('[name="id"]').val();
	hotelSearch.fromDate = $('[name="checkInDate"]').val();
	hotelSearch.toDate = $('[name="checkOutDate"]').val();
	hotelSearch.searchUrl = $('[name="urlHotelName"]').val();
	$.cookie('hotelSearchValues',  JSON.stringify(hotelSearch), { expires : date,  path : '/' });
}

function checkForSearchHotel(form,event) {
	var formValid = form.checkValidity();
	
	var id = $('[name="id"]', form).val();
	
	//in case autocomplete is not selected	
	var urlHotelName = $('[name="hotelName"]').val();
	if(!id){
		$('[name="urlHotelName"]').val(urlHotelName);
	}

	if(formValid) {
		var fromDate = $("[name=checkInDate]", form).val();
		var toDate = $("[name=checkOutDate]", form).val();
		
		fromDate = moment(fromDate, "DD.MM.YYYY");
		toDate = moment(toDate, "DD.MM.YYYY");

		var duration = toDate.diff(fromDate,'days');
		
		if (duration > 30) {
    		event.preventDefault();
    		event.stopPropagation();
			$('#hotelNotFound').modal('show');
		} else {
          	form.classList.add('was-validated');
			$('#hotelLoading').modal('show');
			putHotelCookieSearchValues();
		}
	} else {
    	event.preventDefault();
    	event.stopPropagation();
	}
}